module.exports = __webpack_public_path__ + "img/LUB00116.2fa3c4ff.png";